import { RequestSettingsByVehicle } from '@app/entities/request-settings';

export type VehicleSearchPayload = Readonly<{
  PickUp: PickUpSearch,
  DropOff: DropOffSearch,
  MaxResults?: number,
  RequestSettings?: RequestSettingsByVehicle,
  CurrencyCode?: string,
  SessionToken?: string
}>;

export type PickUpSearch = Readonly<{
  PickUpType: VehiclePlaceType,
  PickUpDateTime: string,
  DestinationCode?: string
  Latitude?: number,
  Longitude?: number,
  PlaceId?: string
}>;

export type DropOffSearch = Readonly<{
  DropOffType: VehiclePlaceType,
  DropOffDateTime?: string,
  DestinationCode?: string,
  Latitude?: number,
  Longitude?: number,
  PlaceId?: string
}>;

export enum VehiclePlaceType {
  Airport = 'Airport',
  City = 'City',
  LatLong = 'LatLong'
}
